import api from '@app/apiExternalStorage'

import type { AxiosRequestConfig } from 'axios'

export const exportFile = async (uri: string): Promise<Blob> => {
  const config: AxiosRequestConfig = { responseType: 'blob' }

  const response = await api.get<Blob>(uri, config)

  return response.data
}
